var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-selector",class:{ '-disabled': _vm.section.disabled }},[_c('DatePicker',{attrs:{"value":_vm.value,"type":_vm.type,"border":false},on:{"input":_vm.dateSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }